import React from 'react';

const CompensationSection = ({ jobData, handleInputChange, errors }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">Compensation</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Minimum Salary
          </label>
          <input
            type="number"
            name="salary_range_min"
            value={jobData.salary_range_min}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="50000"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Maximum Salary
          </label>
          <input
            type="number"
            name="salary_range_max"
            value={jobData.salary_range_max}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="80000"
          />
          {errors.salary_range_max && <p className="text-red-600 text-sm mt-1">{errors.salary_range_max}</p>}
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Currency
          </label>
          <select
            name="currency"
            value={jobData.currency}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="USD">USD</option>
            <option value="MWK">MWK</option>
            <option value="GBP">GBP</option>
            <option value="CAD">CAD</option>
            <option value="AUD">AUD</option>
            <option value="INR">INR</option>
            <option value="JPY">JPY</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default CompensationSection;